import React from 'react';
import Description from './description';
import ToggleableComponent from './toggleableComponent';
import RiskMitigationMeasures from '../riskMitigationMeasures';
import AssociatedEvents from '../associatedEvents';

export default function RiskHistoryBody({
  data = {},
  canEdit = false,
}) {
  return (
    <div>
      <Description
        data={data}
      />
      <ToggleableComponent
        type="stateOfMeasures"
      >
        <RiskMitigationMeasures
          canEdit={canEdit}
          data={data.riskMitigationMeasures}
        />
      </ToggleableComponent>
      <ToggleableComponent
        type="associatedEvents"
      >
        <AssociatedEvents
          data={data.associatedEvents}
        />
      </ToggleableComponent>
    </div>
  );
}
